/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import Loader from '../loader/Loader';

const useStyles = makeStyles(theme => ({
  spaceOneRight: {
    marginRight: theme.spacing(1),
  },
  spaceTwoBottom: {
    marginBottom: theme.spacing(2),
  },
  image: {
    width: '100%',
    minWidth: '20rem',
    minHeight: '10rem',
  },
}));

export default function SubmissionPreviewDialogs({
  submission,
  signatureImageUrl,
  dialogSendSubmission,
  dialogPreviewFacsimile,
  handleFacsimileImageError,
  isLoading,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Dialog open={dialogSendSubmission.isOpen} fullWidth maxWidth="md">
        <DialogTitle>
          <Typography component="span" variant="h2">
            {t('messages.are-you-sure')}
          </Typography>
        </DialogTitle>
        <DialogContent>{t('submissionSend.confirmation')}</DialogContent>

        <DialogActions>
          {isLoading ? (
            <Loader size={30} />
          ) : (
            <>
              <Button color="default" id="cancelSend" onClick={dialogSendSubmission.close}>
                {t('actions.cancel')}
              </Button>
              <Button id="send" color="primary" onClick={dialogSendSubmission.confirm}>
                {t('actions.send.submission')}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={dialogPreviewFacsimile.isOpen} fullWidth maxWidth="md">
        <DialogTitle>
          <Typography variant="h2" component="span" gutterBottom>
            {t('Signer')}
            <span style={{ textTransform: 'capitalize' }}>{submission?.signature?.signerFullName}</span>
          </Typography>
          <Typography variant="subtitle1" component="span" gutterBottom>
            <div>{submission?.signature?.signatureFileName}</div>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <img
            src={signatureImageUrl}
            className={classes.image}
            alt="Facsimile Signature"
            onError={handleFacsimileImageError}
          />
        </DialogContent>
        <DialogActions>
          <Button id="close" color="primary" onClick={dialogPreviewFacsimile.close}>
            {t('actions.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
